import React from 'react';
import {connect} from "react-redux";
import PublicLayout from "../Public";
import {Button, Col, Form, Input, Row, Typography} from "antd";
import language from "../../languages/language";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import prepareDocs from "../../actions/prepareDocs";
import forgot from "../../actions/forgot";

class Login extends React.Component
{

    loginUser=(formValues)=>
    {
        this.props.prepareDocs({...formValues,...this.props.info});
    };

    handleClick=(e)=>
    {
        e.preventDefault();
        this.props.forgot({name:this.props.info.userName});
    };

    render()
    {
        const span=18;
        return <PublicLayout title={'logo'} size={'large'}>
            <TitleAndInfo info={language[this.props.language].userExistsInfo}/>
            <Form ref={this.formRef} onFinish={this.loginUser} className={'regularForm'}
                  initialValues={{userName:this.props.info.userName}}>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="userName"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'username'} readOnly={true} placeholder={language[this.props.language].userLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="password"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input.Password autoComplete="new-password" placeholder={language[this.props.language].passwordLabel}
                                   size={'large'} className={'mb-10'}
                                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].nextLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col onClick={this.handleClick} style={{textAlign:'center'}} span={span}>
                        <Typography.Link className='color-primary' style={{textDecoration:'underline', fontSize:'15px'
                            ,fontWeight:'bold'}}
                                         href="#" target="_self">
                            {language[this.props.language].forgotPassword}</Typography.Link>
                    </Col>
                </Row>
            </Form>
        </PublicLayout>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        info:state.info
    }
}
export default connect(mapStateToProps, {prepareDocs,forgot})(Login);